import { DueAfter as DAfter } from '@/entities/issueTemplate';

type DueAfter = DAfter;

export interface ChecklistTemplateBuilderEditable {
  checklistId: { value: number | null };
  title: { value: string };
  assignees: { value: Array<number | string> };
  associateAssignees: { value: Array<number | string> };
  dueIn: { value: null | DueAfter };
  assignedGroups: { value: Array<number | string> };
}

export const emptyChecklistTemplateBuilder = (): ChecklistTemplateBuilderEditable => ({
  checklistId: {
    value: null,
  },
  title: {
    value: '',
  },
  assignees: {
    value: [],
  },
  dueIn: {
    value: {
      weeks: 1,
      days: null,
      hours: null,
      minutes: null,
    },
  },
  assignedGroups: {
    value: [],
  },
  associateAssignees: {
    value: [],
  },
});
